import { MRT_ColumnDef } from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PaperTableHeader } from '../../_components/table/header.table';
import { StandardTable } from '../../_components/table/standard.table';
import { TABLE_FILTER } from '../../_const/tableFilter.const';
import { getDate } from '../../_helpers/dateTime.helper';
import { handleErrorResponse } from '../../_helpers/handleResponse.helper';
import { auctionLogService } from '../../_services/auctionLog.service';
import { AuctionLogActionEnum } from '../../_common/enum/auctionLogActionEnum';
import { SearchTableHeader } from '../../_components/table/search.table';



export function AuctionLogIndex() {
    const [data, setData] = useState<any>({ items: [], count: 10 });
    const [filter, setFilter] = useState({ ...TABLE_FILTER, orderBy: "createdDate", userName: "", createdBy: "", auctionLogActionId: "" });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const fetchData = async () => {
        setIsLoading(true);
        return await auctionLogService.getAll(filter)
            .then(
                json => {
                    setData(json);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [filter]);

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [

            {
                accessorKey: 'auctionLogActionId',
                header: 'Action',
                accessorFn: (rowData: any) => <>{AuctionLogActionEnum[rowData.auctionLogActionId]}</>,
            },
            {
                accessorKey: 'createdDate',
                header: 'Date',
                accessorFn: (rowData: any) => <>{rowData.createdDate != null ? getDate(rowData.createdDate) : null}</>,
            },
            {
                accessorKey: 'createdByName',
                header: 'Created By',
            },
            {
                accessorKey: 'userName',
                header: 'User',
                accessorFn: (rowData: any) => <>{!!rowData.userName ? rowData.userName : "-"}</>,
            },
            {
                accessorKey: 'value',
                header: 'Value',
                accessorFn: (rowData: any) => <>{!!rowData.value ? rowData.value : "-"}</>,
            },
        ],
        []
    );

    return (
        <>
            <PaperTableHeader title="Auction Log" buttons={[
                { icon: "refresh", label: "Refresh", onClick: fetchData }
            ]} />

            <SearchTableHeader inputs={[
                { label: "User Name", name: "userName", onChange: setFilter, value: filter.userName },
                { label: "Created By", name: "createdBy", onChange: setFilter, value: filter.createdBy },
                // { label: "Action", name: "auctionLogActionId", onChange: setFilter, value: filter.auctionLogActionId },
            ]} />

            <StandardTable
                columns={columns}
                data={data}
                filter={filter}
                setFilter={setFilter}
                loading={isLoading}
            />

        </>
    );
}
